import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent implements OnInit {

  constructor() {
  	setInterval(()=>this.blinked(),1000);

   }

	hours: string;
	minutes: string;
	seconds: string;
	private timerId = null;
	blink = false;

	ngOnInit() {
		this.setCurrentTime();
		this.timerId = this.updateTime();
	}

	ngOnDestroy() {
		clearInterval(this.timerId);
	}

	private setCurrentTime() {
		const time = new Date(Date.now());
		this.hours = this.leftPadZero(time.getHours());
		this.minutes = this.leftPadZero(time.getMinutes());
		this.seconds = this.leftPadZero(time.getSeconds());
	}

	private updateTime() {
		setInterval(() => {
		  this.setCurrentTime();
		}, 1000);
	}

	private leftPadZero(value: number) {
		return value < 10 ? `0${value}` : value.toString();
	}
	blinked(){
		this.blink = !this.blink;
	}
}
